import { State } from 'xstate';

import { createPaymentProfile } from './createPaymentProfile';

type PaymentProfileMachine = typeof createPaymentProfile;

type PaymentProfileState = State<PaymentProfileMachine['context']>;

export const getPaymentProfile = (machineState: PaymentProfileState) => {
  const { paymentMethod, billingAddress, validationSchema, tokenizationError } =
    machineState.context;

  return {
    paymentMethod: {
      ...paymentMethod,
      hostedFieldsErrors: tokenizationError?.invalidFields || [],
    },
    billingAddress,
    validationSchema,
  };
};

export const getPaymentProfileProcessing = (
  machineState: PaymentProfileState
) => {
  return [
    'validatePaymentMethod',
    'tokenizePaymentMethod',
    'createPaymentProfile',
    'connectProfileWithSubscription',
    'replacePaymentProfiles',
  ].some((state) => machineState.matches(state));
};

export const getProfileConnectionError = (machineState: PaymentProfileState) =>
  machineState.matches('connectProfileError');

export const getRequiredFields = (machineState: PaymentProfileState) =>
  machineState.context.requiredFields;

export const getPaymentProfileErrors = (machineState: PaymentProfileState) => {
  return {
    tokenization: machineState.context.tokenizationError,
  };
};
export const getPaymentProfilesReplacementError = (
  machineState: PaymentProfileState
) => machineState.matches('replacePaymentProfilesError');

export const getPaymentProfilesIdsForReplacement = (
  machineState: PaymentProfileState
) => machineState.context.paymentProfiles.idsForReplacement;

export const getPaymentProfilesSubscriptions = (
  machineState: PaymentProfileState
) => machineState.context.paymentProfiles.subscriptions;

export const getPaymentProfilesReplacementProcessing = (
  machineState: PaymentProfileState
) => machineState.matches('replacePaymentProfiles');

export const paymentProfileSelectors = {
  getProfileConnectionError,
  getRequiredFields,
  getPaymentProfileErrors,
  getPaymentProfileProcessing,
  getPaymentProfile,
  getPaymentProfilesIdsForReplacement,
  getPaymentProfilesSubscriptions,
  getPaymentProfilesReplacementError,
  getPaymentProfilesReplacementProcessing,
};
